
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class UserQualificationCallViewModel extends Model<UserQualificationCallViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string' },
		{ name: 'username', type: 'string' },
		{ name: 'userId', type: 'string' },
		{ name: 'callCount', type: 'number' },
		{ name: 'totalValue', type: 'number' },
		{ name: 'team', type: 'string' }
	];
	[key: string]: any;
	
	public name: string;
	public username: string;
	public userId?: string;
	public callCount: number;
	public totalValue: number;
	public team: string;
    
	constructor(){
		super();
		this.name = '';
		this.username = '';
		this.userId = undefined;
		this.callCount = 0;
		this.totalValue = 0;
		this.team = '';
		
	}
	getProperties(){
		return UserQualificationCallViewModel.classProperties;
	}
}

